import { bindActionCreators } from 'redux';
import forEach from 'lodash/forEach';
import { me } from 'legacy/src/queries';
import {
  emptyImpersonaterLocalStorage,
  getStudentTokens,
} from 'legacy/src/components/impersonating/utils';
import {
  logoutImpersonate,
  setEducationPeriod,
  setIsReadOnly,
  setSectionId,
  setStudentId,
  setTeacherNav,
  setSubject,
  setCurrentSubject,
  setTeacherClasses,
} from 'legacy/src/components/impersonating/state/actions';
import { pageReloading } from 'legacy-src/actions/commonActions';
import { login } from 'legacy/src/components/auth/actions';
import { resetCourseOutline } from 'legacy-src/actions/courseOutline';
import { setNavLoading, setNavData } from 'legacy/src/actions/nav';
import { setItems } from 'legacy-src/actions/classes';
import {
  IMPERSONATING_TELEMETRY_TYPES,
  LC_CONSTANTS,
} from '../utils/constants';
import postImpersonatingTelemetryData from '../utils/telemetry';
import {
  unitsClient,
  fymClient,
  impersonatorFymClient,
  reportsClient,
  wizardsClient,
} from 'legacy-src/utility/GraphqlClients';

/**
 * @params {func} dispatch - redux method
 * @params {object} navData - the nav data
 * @params {function} callback
 * @params {object} impersonating - redux object
 * */
export default ({
  dispatch,
  router,
  navData,
  impersonating,
  callback = () => {},
  userData,
}) => {
  const sagaDispatch = bindActionCreators(
    {
      logoutImpersonateAction: logoutImpersonate,
      pageReloading,
      pageReloadingFulfill: pageReloading.fulfill,
      loginSuccess: login.success,
      setNavLoadingAction: setNavLoading,
      setNavDataAction: setNavData,
      setItemsAction: setItems,
    },
    dispatch,
  );

  const { teacherClasses } = impersonating;

  const doLogout = () => {
    sagaDispatch.setNavLoadingAction(true);
    sagaDispatch.pageReloading();

    const {
      accessToken: studentAccessToken,
      refreshToken: studentRefreshToken,
      expires: studentExpires,
    } = getStudentTokens();

    sagaDispatch.logoutImpersonateAction({
      headers: {
        skipOverride: true,
        accessToken: studentAccessToken,
        refreshToken: studentRefreshToken,
        expires: studentExpires,
      },
      onReady: () => {
        // send stop data for the current impersonated student
        const stopImpersonatedTelData = {
          eventType: IMPERSONATING_TELEMETRY_TYPES.STOP,
          subjectId: window.localStorage.getItem(LC_CONSTANTS.ICURRENTSUBJECT),
          studentId: window.localStorage.getItem(LC_CONSTANTS.STUDENT_ID),
          sectionId: window.localStorage.getItem(LC_CONSTANTS.SECTION_ID),
          userData,
          teacherClasses,
        };
        postImpersonatingTelemetryData(stopImpersonatedTelData);
        emptyImpersonaterLocalStorage();
        setIsReadOnly(dispatch, false);
        setStudentId(dispatch, null);
        setSectionId(dispatch, null);
        setEducationPeriod(dispatch, null);
        setTeacherNav(dispatch, []);
        setTeacherClasses(dispatch, []);
        setSubject(dispatch, null);
        setCurrentSubject(dispatch, null);
        sagaDispatch.setNavLoadingAction(true);
        sagaDispatch.setNavDataAction(navData);

        fymClient
          .query({
            query: me,
            fetchPolicy: 'network-only',
          })
          .then(({ data }) => {
            forEach(
              [
                unitsClient,
                fymClient,
                impersonatorFymClient,
                reportsClient,
                wizardsClient,
              ],
              async (client) => {
                client && client.resetStore && (await client.resetStore());
              },
            );

            const {
              currentEducationPeriod,
              educationPeriods,
              nextEducationPeriod,
            } = data;
            sagaDispatch.loginSuccess({
              ...data,
              me: data.me,
              educationPeriod: {
                currentEducationPeriod,
                educationPeriods,
                nextEducationPeriod,
              },
            });
            /**
             * Reset CO redux store for current subject
             * */
            resetCourseOutline(dispatch);
            sagaDispatch.setItemsAction([]);
            const { currentSubject } = impersonating;
            document
              .querySelector('#root')
              .classList.remove('is-impersonating');
            window.localStorage.setItem(
              LC_CONSTANTS.IMPERSONATOR_REDIRECT_SUBJECT_ID,
              currentSubject,
            );
            callback();
            router.replace(`/${currentSubject}/home`);
            sagaDispatch.pageReloadingFulfill();
          });
      },
    });
  };

  return [
    {
      logoutDispatchers: sagaDispatch,
    },
    doLogout,
  ];
};
